module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h56dG"))).then(() => parcelRequire('d0iPb'));